import { el, setAttr } from 'redom';

import { getQuotedMessageSenderName, getQuotedMessageText } from '../../../../utilities/quoted-message';

class QuotedMessageDisplay {

  constructor(configuration) {

    this.onClick = configuration.onClick;

    this.senderDisplay = el('span.quoted-message-sender');
    this.textDisplay = el('span.quoted-message-text');

    this.el = el('button.quoted-message-display-main', {
      type: 'button',
      onclick: this.handleClick.bind(this)
    }, [
      this.senderDisplay,
      this.textDisplay
    ]);

    this.hide();

  }

  handleClick(event) {

    event.preventDefault();
    event.stopPropagation();

    this.onClick();

  }

  hide() {

    setAttr(this.el, { style: { display: 'none' } });

  }

  update(quotedMessage) {

    if (quotedMessage === void 0 || quotedMessage === null) {
      this.hide();
      return;
    }

    this.senderDisplay.textContent = getQuotedMessageSenderName(quotedMessage);
    this.textDisplay.textContent = getQuotedMessageText(quotedMessage);

    setAttr(this.el, { style: { display: 'flex' } });

  }

}

export default QuotedMessageDisplay;
